import MobileOutlined from '@ant-design/icons/lib/icons/MobileOutlined';
import QrcodeOutlined from '@ant-design/icons/lib/icons/QrcodeOutlined';

import { AuthenticatorAppGrid } from '@pages/TOTPSetup';

export function AuthenticatorOption({
  onClick,
  customText
}: {
  onClick: () => void;
  customText?: string;
}) {
  return (
    <OptionWrapper onClick={onClick}>
      <div className="flex flex-col gap-4">
        <QrcodeOutlined style={{ fontSize: '50px' }} />
        <div className="flex flex-row items-baseline gap-2 whitespace-nowrap text-xl">
          <p className="text">Authentication app</p>
          <p className="text-xs text-content-positive-strong">Recommended</p>
        </div>
        <p className="text-xs">
          {customText ||
            'Verification codes are created by an app on your phone.'}
        </p>
        <AuthenticatorAppGrid />
      </div>
    </OptionWrapper>
  );
}

export function SMSOption({
  onClick,
  customText
}: {
  onClick: () => void;
  customText?: string;
}) {
  return (
    <OptionWrapper onClick={onClick} className="bg-surface-soft">
      <MobileOutlined style={{ fontSize: '50px' }} />
      <div className="text-xl font-semibold text-content-secondary">
        SMS (deprecated)
      </div>
      <p className="text-xs">{customText || 'Request a code through SMS.'}</p>
    </OptionWrapper>
  );
}

export function OptionWrapper({
  children,
  onClick,
  className
}: {
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
}) {
  return (
    <div
      className={`only-shadow flex h-[300px] cursor-pointer flex-col items-center justify-evenly rounded-2xl bg-white p-4 hover:bg-surface-hover ${className}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
